class @App.Components.TededFilter
  constructor: ->
    @$body = $('body')
    @activeSelector = "[aria-checked='true']"
    @activeClass = 'tdd-filter--checked'

    @injectAriaAttributes()
    # To Do: keyboard accessibility
    @setupInitalState()
    @bindElements()

  bindElements: ->
    # Bind filter option to update on click
    @$body.on 'click.tededfilter.option', '[data-filter-opt]', (e) =>
      $target = $(e.target)
      if not $target.attr 'data-filter-opt'
        $target = $target.closest '[data-filter-opt]'

      if $target
        @toggleActive($target)

    # Bind reset option to clear any related filters
    @$body.on 'click.tededfilter.clear', '[data-filter-clear]', (e) =>
      e.preventDefault()
      name = $(e.currentTarget).data('filter-clear')
      $("[data-filter-list='#{name}'] [data-filter-opt]").each((i, el) =>
        @toggleActive($(el), false)
      )

  setupInitalState: ->
    # Add active class to any pre-selected options
    $('[data-filter-opt]').wrapInner '<span data-filter-label></span>'

    $('[data-filter-opt]' + @activeSelector)
      .find('[data-filter-label]')
      .addClass @activeClass

    # Update comboboxes with any pre-selected data
    $('[data-filter-combobox]').each (i, el) =>
      @updateCombobox($(el).data('filter-combobox'))

    # Update list counters with any pre-selected data
    $('[data-filter-list]').each (i, el) =>
      @updateCounter($(el).data('filter-list'))

  # Add aria role attirubtes to elements.
  injectAriaAttributes: () ->
    $('[data-filter-list]').attr('role', 'listbox')
    $('[data-filter-opt]').attr('role', 'menuitemcheckbox')
    $('[data-filter-opt]').attr 'aria-checked', (i, val) ->
      if val is 'true' then 'true' else 'false'

  # Format the combobox text to return the text of the first two results and
  # then the count of additional fitlers, or the default text.
  formatComboboxText: (first, second, rest...) ->
    first = $(first).text().trim() if first? and $(first).text()?
    second = $(second).text().trim() if second? and $(second).text()?

    if first and second and rest.length > 0
      "#{first}, #{second}, (+#{rest.length})"
    else if first and second
      "#{first}, #{second}"
    else if first
      first

  # Update the combobox text.
  updateCombobox: (name) ->
    selected = $("[data-filter-opt='#{name}']" + @activeSelector)
    filterList = $("[data-filter-combobox='#{name}']")
    content = filterList.data('empty')
    if selected.length > 0
      long = $('<span />').addClass('tdd-filter__label-long').text(@formatComboboxText(selected...))
      short = $('<span />').addClass('tdd-filter__label-short').text(selected.length + ' added')
      if selected.length < 2 and $(selected).data('short-name')?
        short.text($(selected).data('short-name'))
      content = $('<span />').append(short).append(long)
    filterList.html(content)

  # Update the counter value to the number of selected children.
  updateCounter: (name) ->
    selected = $("[data-filter-list='#{name}'] [data-filter-opt]" + @activeSelector).length
    $("[data-filter-counter='#{name}']").text selected

  # Toggle the selected state of a filter option
  toggleActive: ($option, checked = 'toggle') ->
    if checked is 'toggle'
      checked = if $option.attr('aria-checked') is 'true' then 'false' else 'true'
    name = $option.data('filter-opt')

    if checked is 'true' and $("[data-filter-combobox='#{name}']").data('filter-mode') is 'single'
      $("[data-filter-opt='#{name}']").attr('aria-checked', 'false')
      $("[data-filter-opt='#{name}'] [data-filter-label]").removeClass @activeClass

    $option.attr('aria-checked', checked)
    label = $option.find('[data-filter-label]')
    if checked is 'true'
      label.addClass(@activeClass)
    else
      label.removeClass(@activeClass)
    @optionUpdated($option)

  optionUpdated: ($option) ->
    $option.parents('[data-filter-list]').each((i, e) =>
      @updateCounter($(e).data('filter-list'))
    )
    @updateCombobox($option.data('filter-opt'))

$(document).on 'turbo:load', ->
  if $('[data-filter-opt]').length > 0
    new App.Components.TededFilter
